import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { ApiService } from "@bca-core/services/api.service";
import { MessageType } from "@bca-shared/models/_enums";
import { IActionCode } from "@bca-shared/models/action-code";
import { IMessage } from "@bca-shared/models/message";
import { AvoService } from "@bca-shared/utils/avo/avo.service";
import { IActionCodeResponse } from "@bca-verify/models/action-code-response";
import { EMPTY } from "rxjs";
import { catchError, filter, map, tap } from "rxjs/operators";

@Component({
  selector: "bca-action-code",
  templateUrl: "action-code.component.html",
  styleUrls: ["action-code.component.scss"],
})
export class ActionCodeComponent implements OnInit {
  @Input()
  actionCode: IActionCode;

  @Output()
  remove = new EventEmitter<void>();
  @Output()
  add = new EventEmitter<IActionCode>();
  @Output()
  error = new EventEmitter<IMessage>();

  isTileExpanded: boolean;
  loading: boolean;
  actionCodeInput: string;

  constructor(
    private _apiService: ApiService,
    private _avoService: AvoService,
  ) {}

  ngOnInit(): void {
    const { actionCode } = this;
    this.isTileExpanded = actionCode != null;
  }

  validateActionCode(): void {
    const { actionCodeInput, error, add, remove } = this;
    if (!actionCodeInput) return;

    this.loading = true;

    this._apiService
      .getActionCode(actionCodeInput)
      .pipe(
        catchError((e) => {
          const message = {
            body: "NOTIFICATION.ERROR.ACTION_CODE",
            type: MessageType.ERROR,
            context: { error: e },
            originalException: e,
          };
          error.emit(message);
          this.loading = false;
          return EMPTY;
        }),
        tap((response: IActionCodeResponse) => {
          const { success } = response;
          if (!success) {
            this.actionCodeInput = null;
            remove.emit();
          }
          this.loading = false;
        }),
        filter((response: IActionCodeResponse) => response.success),
        map((response: IActionCodeResponse) => {
          const { code, description } = response;
          return { code, description } as IActionCode;
        }),
      )
      .subscribe((actionCode) => add.emit(actionCode));
  }

  toggleExpanded(): void {
    const { actionCode } = this;
    if (!actionCode) {
      this.isTileExpanded = !this.isTileExpanded;
    }
    this._avoService.expandableClick({
      clickText: "Voer uw actiecode in",
      websiteSection: "ns-zakelijk|checkout|4-controleren",
      uniqueName: "actiecode",
      description: "user_enters_action_code",
      opened: this.isTileExpanded,
    });
  }
}
